import Main from './ui/Main';

export default Main;